import { getCookie } from '../utils/domUtils';
import { CookiesProviderTypes } from './cookies.types';

export const providerKeys: Array<CookiesProviderTypes> = [
  'stats_cookie',
  'logrocket_cookie',
  'onesignal_cookie',
  'facebook_retargeting_cookie',
  'twitter_cookie',
  'ga_cookie',
  'pardot_cookie',
  'wisepops_cookie',
];

export const cookiesPolicyName = 'cookies_policy';

export function getCookiesPolicy() /* : ?{} */ {
  try {
    const cookieString = getCookie(cookiesPolicyName);

    if (cookieString) {
      return JSON.parse(cookieString);
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
